import { DateFormat, isToday } from "common";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useRef, useState } from "react";
import { VirtuosoHandle } from "react-virtuoso";
import FullCalendar from "@fullcalendar/react";

export const useScrollToTimeslotList = (start: Dayjs, filters: any, timeslots: any[], isRealTimeUpdate: boolean) => {
    const virtuoso = useRef<VirtuosoHandle>(null);
    const [scrollIndex, setScrollIndex] = useState(0);

    useEffect(() => {
        if (isRealTimeUpdate) {
            return;
        }

        const cutOff = dayjs().format("HHmm");
        const newScrollIndex = isToday(start)
            ? timeslots.findIndex(({ time }) => time && time > Number.parseInt(cutOff, 10))
            : 0;
        setScrollIndex(newScrollIndex);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, timeslots, isRealTimeUpdate]);

    useEffect(() => {
        if (isRealTimeUpdate) {
            return;
        }

        virtuoso.current?.scrollToIndex({ index: scrollIndex });
    }, [scrollIndex, isRealTimeUpdate]);

    return { virtuoso };
};

export const useScrollToTimeslotCalendar = (start: Dayjs, timeslots: any[], isRealTimeUpdate: boolean) => {
    const calendarRef = useRef<FullCalendar>(null);
    const [scrollDate, setScrollDate] = useState<Dayjs | null>(null);

    useEffect(() => {
        if (isRealTimeUpdate) {
            return;
        }

        const cutOff = dayjs().format("HHmm");
        const nextTimeslot = dayjs(start).isSame(dayjs(), "day")
            ? timeslots.find(({ time }) => time && Number.parseInt(time, 10) > Number.parseInt(cutOff, 10))
            : null;

        setScrollDate(nextTimeslot ? dayjs(nextTimeslot.arrivalDatetime) : dayjs());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRealTimeUpdate]);

    useEffect(() => {
        if (isRealTimeUpdate) {
            return;
        }

        if (scrollDate && calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            calendarApi.scrollToTime(scrollDate.format(DateFormat.TIME_24H));
        }
    }, [scrollDate, isRealTimeUpdate]);

    return { calendarRef };
};
